import { type ReactNode, type FC } from "react";
import styled from "styled-components";
import { useSidebarState } from "./state";

const SubMenuAnimation = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s;

  &.submenu-open {
    grid-template-rows: 1fr;
  }
`;
const ContentWrapper = styled.div`
  overflow: hidden;
`;

type SubMenuProps = {
  children: ReactNode;
  id: string;
};

export const SubMenu: FC<SubMenuProps> = ({ children, id }) => {
  const sidebarState = useSidebarState();

  return (
    <SubMenuAnimation
      className={
        sidebarState.openedSubMenu === id && !sidebarState.isCollapsed
          ? "submenu-open"
          : ""
      }
    >
      <ContentWrapper>{children}</ContentWrapper>
    </SubMenuAnimation>
  );
};
